module.exports = __webpack_public_path__ + "img/lb1.bf929698.png";